export const SDK_VERSION = '7.56.0';
